<template>
	<div id="modal-right" class="modal fade" data-backdrop="true">
        <div class="modal-dialog modal-right">
            <div class="modal-content h-100 no-radius">
                <div class="modal-header ">
                    <div class="modal-title text-md">Filters</div>
                    <button class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
	                <div class="row">
	                    <div class="col-3">
	                        <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
	                        	<a class="nav-link active" data-toggle="pill" href="#v-name" role="tab">Company Name</a>
	                            <a class="nav-link" data-toggle="pill" href="#v-industry" role="tab">Industry</a>
	                            <a class="nav-link" data-toggle="pill" href="#v-country" role="tab">Country</a>
	                            <a class="nav-link" data-toggle="pill" href="#v-employee" role="tab">Employee Size</a>
	                        </div>
	                    </div>
	                    <div class="col-9">
	                        <div class="tab-content" id="v-pills-tabContent">
	                        	<div class="tab-pane fade show active" id="v-name" role="tabpanel" aria-labelledby="v-name-tab">
	                 				<div class="jp-multiselect">
				            			<div class="from-panel">
					            			<label><strong>Not Selected</strong></label>
				                			<select name="from[]" class="form-control" size="7" multiple="multiple">
				                				<option v-for="name in filterData['name']">
				                					{{ name }}
				                				</option>
				                			</select>
				            			</div>
				            			<div class="move-panel">
				                			<button type="button" class="btn-move-all-right btn-primary"></button>
				                			<button type="button" class="btn-move-selected-right"></button>
				                			<button type="button" class="btn-move-all-left"></button>
				                			<button type="button" class="btn-move-selected-left"></button>
				            			</div>
				            			<div class="to-panel">
					            			<label><strong>Selected</strong></label>
				                			<select ref="nameSelections" name="to[]" class="form-control" size="7" multiple="multiple">
				                			</select>
				            			</div>
				        			</div>
	                            </div>
	                            <div class="tab-pane fade show" id="v-industry" role="tabpanel" aria-labelledby="v-industry-tab">
	                 				<div class="jp-multiselect">
				            			<div class="from-panel">
					            			<label><strong>Not Selected</strong></label>
				                			<select name="from[]" class="form-control" size="7" multiple="multiple">
				                				<option v-for="industry in filterData['industry']">
				                					{{ industry }}
				                				</option>
				                			</select>
				            			</div>
				            			<div class="move-panel">
				                			<button type="button" class="btn-move-all-right btn-primary"></button>
				                			<button type="button" class="btn-move-selected-right"></button>
				                			<button type="button" class="btn-move-all-left"></button>
				                			<button type="button" class="btn-move-selected-left"></button>
				            			</div>
				            			<div class="to-panel">
					            			<label><strong>Selected</strong></label>
				                			<select ref="industrySelections" name="to[]" class="form-control" size="7" multiple="multiple">
				                			</select>
				            			</div>
				        			</div>
	                            </div>
	                            <div class="tab-pane fade" id="v-country" role="tabpanel" aria-labelledby="v-country-tab">
	                            	<div class="jp-multiselect">
				            			<div class="from-panel">
					            			<label><strong>Not Selected</strong></label>
				                			<select name="from[]" class="form-control" size="7" multiple="multiple">
							                    <option v-for="country in filterData['country']">
				                					{{ country }}
				                				</option>
				                			</select>
				            			</div>
							            <div class="move-panel">
							                <button type="button" class="btn-move-all-right btn-primary"></button>
							                <button type="button" class="btn-move-selected-right"></button>
							                <button type="button" class="btn-move-all-left"></button>
							                <button type="button" class="btn-move-selected-left"></button>
							            </div>
							            <div class="to-panel">
								            <label><strong>Selected</strong></label>
							                <select ref="countrySelections" name="to[]" class="form-control" size="7" multiple="multiple">
							                </select>
							            </div>
				        			</div>
	                            </div>
	                            <div class="tab-pane fade" id="v-employee" role="tabpanel" aria-labelledby="v-employee-tab">
	                            	<div class="jp-multiselect">
				            			<div class="from-panel">
					            			<label><strong>Not Selected</strong></label>
				                			<select name="from[]" class="form-control" size="7" multiple="multiple">
							                    <option v-for="employeeSize in filterData['numberofemployees']">
				                					{{ employeeSize }}
				                				</option>
				                			</select>
				            			</div>
							            <div class="move-panel">
							                <button type="button" class="btn-move-all-right btn-primary"></button>
							                <button type="button" class="btn-move-selected-right"></button>
							                <button type="button" class="btn-move-all-left"></button>
							                <button type="button" class="btn-move-selected-left"></button>
							            </div>
							            <div class="to-panel">
								            <label><strong>Selected</strong></label>
							                <select ref="numberofemployeesSelections" name="to[]" class="form-control" size="7" multiple="multiple">
							                </select>
							            </div>
				        			</div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
                </div>
                <div class="modal-footer">
                    <div class="col-6">
	                    <button type="button" class="btn btn-light" data-dismiss="modal" v-on:click="clearFilters">Clear</button>
	                    <button type="button" class="btn btn-light" data-dismiss="modal">Save as Favorite</button>
	                    <button type="button" class="btn btn-light" data-dismiss="modal">Load Favorite</button>
                    </div>
                    
                    <div class="col-6">
	                    <div class="d-flex justify-content-end">
		                    <button type="button" class="btn btn-primary ml-1" data-dismiss="modal" v-on:click="createFilters">Apply</button>
		                    <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
	                    </div>
                    </div>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
    </div>
</template>


<script>
  export default {
    name: 'FilterModal',
    props: {
      'filterData': {
      	type: Object
      }
    },
    data(){
    	return{
    		//industrySelections: [],
    		//countrySelections: [],
    	};
    },
    methods: {
      	createFilters(){
      		var selected = {'name': [], 'industry': [], 'country': [], 'numberofemployees': []};
      		//console.log(this.$refs['industrySelections'].options);

      		// Loop over all filters and push them
      		for(var key in selected){
      			for (var i = 0; i < this.$refs[key + 'Selections'].options.length; i++) {
      				var value = this.$refs[key + 'Selections'].options[i].value;
      				if(key=='numberofemployees'){
      					value = parseInt(value);
      				}
      				selected[key].push(value);
      			}
      		}
      		
      		for(var key in selected){
          		if(selected[key].length==0){
					//selected[key] = [...this.filterData[key]];
					//selected[key].push(''); // include unknown*/
					delete selected[key];
          		}
        	}
      		this.$emit('filter', selected);
      		console.log(selected);
      	},
      	clearFilters(){
      		this.$emit('clear');
      	},
    },
    mounted(){
    	require('../../static/assets/js/jquery.multi-selection.v1');
    	$(".jp-multiselect").jQueryMultiSelection();
    }
  };
</script>

<style src='../../static/assets/css/jquery-multi-selection.css'></style>



// WEBPACK FOOTER //
// src/components/FilterModal.vue